import styled from 'styled-components';
import { BiPlus, BiMinus } from 'react-icons/bi';

import { addFocusStyle } from '../../lib/mixins';
import { pxToRem, svgComponentToDataURI } from '../../lib/utils';

export const StyledSection = styled.section`
  display: flex;
  flex-flow: row;
  justify-content: center;
  padding: ${pxToRem(40)} ${({ theme }) => pxToRem(theme.sizes.edgeSpacing)};
  background-color: ${({ theme }) => theme.colors.b};
`;

export const StyledWrapper = styled.div`
  flex-basis: ${({ theme }) => pxToRem(theme.breakpoints.medium)};
`;

export const StyledTitle = styled.h3`
  margin: 0 0 ${pxToRem(25)} 0;
  font-family: ${({ theme }) => theme.fonts.headings};
  font-size: ${pxToRem(28)};
  font-weight: 700;
  line-height: ${pxToRem(36)};
`;

export const StyledList = styled.ul`
  margin: 0;
  padding: 0;
`;

export const StyledListItem = styled.li`
  position: relative;
  padding: ${pxToRem(10)} 0;
  list-style: none;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 30%;
    width: 40%;
    border-bottom: 1px solid ${({ theme }) => theme.colors.d};
  }

  &:first-child {
    padding-top: 0;
  }
`;

export const StyledQuestion = styled.h4`
  position: relative;
  margin: 0;
  padding: ${pxToRem(10)} ${pxToRem(30)} ${pxToRem(10)} 0;
  font-size: ${pxToRem(17)};
  font-weight: 600;
  line-height: ${pxToRem(22)};
  cursor: pointer;
  transition: color 0.5s ease;

  &::after {
    content: '';
    position: absolute;
    top: ${pxToRem(10)};
    right: 0;
    width: ${pxToRem(22)};
    height: ${pxToRem(22)};
    background-repeat: no-repeat;
    background-position: right center;

    ${(props) =>
      props.isOpen
        ? `
      background-image: url('${svgComponentToDataURI(<BiMinus size="1.5rem" />)}');
    `
        : `
      background-image: url('${svgComponentToDataURI(<BiPlus size="1.5rem" />)}');
    `}
  }

  &:hover {
    color: ${({ theme }) => theme.colors.brand};
  }

  &:focus {
    ${addFocusStyle()}
  }
`;

export const StyledAnswer = styled.p`
  margin: 0;
  padding-right: ${pxToRem(30)};
  color: ${({ theme }) => theme.colors.f};
  font-size: ${pxToRem(15)};
  line-height: ${pxToRem(20)};
  overflow: hidden;
  transition: opacity 0.5s ease;

  ${(props) =>
    props.isOpen
      ? `
    height: auto;
    padding-bottom: ${pxToRem(15)};
    opacity: 1;
    visibility: visible;
  `
      : `
    height: 0;
    opacity: 0;
    visibility: hidden;
  `}
`;
